// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.spu-capture-table > thead > tr.header-row > th {
  font: bold 15px/15px "Roboto";
  letter-spacing: 0.3px;
  color: #424242;
  background-color: #FFF;
  top: 0;
  position: sticky;
}

table.spu-capture-table > thead > tr.header-row > th:nth-child(n+5) {
  border-left: 1px #A0A0A0 solid;
}

table.spu-capture-table > thead > tr.header-row > th:last-child {
  border-top-right-radius: 4px;
}

table.spu-capture-table > thead > tr.header-row > th.waypoint {
  border-top-left-radius: 4px;
  background-color: #2a989c;
  border-bottom: 1px #FFF solid;
  border-right: 1px #FFF solid;
  color: #FFF;
}

table.spu-capture-table > thead > tr.header-row > th.pole {
  background-color: #5daaad;
  border-bottom: 1px #FFF solid;
  border-right: 1px #FFF solid;
  color: #FFF;
}

table.spu-capture-table > thead > tr.header-row > th.account {
  background-color: #8cb8ba;
  border-bottom: 1px #FFF solid;
  border-right: 1px #FFF solid;
  color: #FFF;
}

table.spu-capture-table > thead > tr.header-row > th.total-usage {
  background-color: #82c44c;
}

table.spu-capture-table > tbody > tr.data-row:nth-child(even) {
  font: bold 11px/15px "Roboto";
  letter-spacing: 0.22px;
  color: #424242;
  background-color: #f4f4f4;
}

table.spu-capture-table > tbody > tr.data-row > td {
  border-bottom: none;
}

table.spu-capture-table > tbody > tr.data-row > td:nth-child(n+2) {
  font: bold 12px/15px Roboto;
}

table.spu-capture-table > tbody > tr.data-row > td:nth-child(n+5) {
  border-left: 1px #A0A0A0 solid;
}

table.spu-capture-table > tbody > tr.data-row > td.waypoint {
  border-right: 1px #FFF solid;
  color: #FFF;
}

table.spu-capture-table > tbody > tr.data-row:nth-child(even) > td.waypoint {
  background-color: #2a989c;
}

table.spu-capture-table > tbody > tr.data-row:nth-last-child(1) > td.waypoint {
  border-bottom-left-radius: 4px;
}

table.spu-capture-table > tbody > tr.data-row:nth-child(odd) > td.waypoint {
  background-color: #2c9fa2;
}

table.spu-capture-table > tbody > tr.data-row > td.pole {
  border-right: 1px #FFF solid;
  color: #FFF;
}

table.spu-capture-table > tbody > tr.data-row:nth-child(even) > td.pole {
  background-color: #5daaad;
}

table.spu-capture-table > tbody > tr.data-row:nth-child(odd) > td.pole {
  background-color: #61b2b5;
}

table.spu-capture-table > tbody > tr.data-row > td.account {
  background-color: #8cb8ba;
  border-right: 1px #FFF solid;
  color: #FFF;
}

table.spu-capture-table > tbody > tr.data-row:nth-child(even) > td.account {
  background-color: #8cb8ba;
}

table.spu-capture-table > tbody > tr.data-row:nth-child(odd) > td.account {
  background-color: #91c1c3;
}

table.spu-capture-table > tbody > tr.data-row > td.total-usage {
  border-right: 1px #FFF solid;
  color: #424242;
}

table.spu-capture-table > tbody > tr.data-row:nth-child(even) > td.total-usage {
  background-color: #82c44c;
}

table.spu-capture-table > tbody > tr.data-row:nth-child(odd) > td.total-usage {
  background-color: #92c46d;
}

table.spu-capture-table > tbody > tr.data-row.multi:nth-child(even) {
  background-color: #d2e788;
}

table.spu-capture-table > tbody > tr.data-row.multi:nth-child(odd) {
  background-color: #c5e369;
}

table.spu-capture-table > tbody > tr.data-row input {
  text-align: left;
  font: 700 12px/15px Roboto;
  letter-spacing: 0.26px;
  color: #424242;
  border: none;
  background-color: transparent;
  padding: 0px;
  margin-left: 10px;
  cursor: text !important;
}

table.spu-capture-table > tbody > tr.data-row input:focus {
  outline: none;
  border-bottom: 1px solid;
  margin-bottom: -1px;
}

table.spu-capture-table > tbody > tr.data-row input::-webkit-outer-spin-button,
table.spu-capture-table > tbody > tr.data-row input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
table.spu-capture-table > tbody > tr.data-row input[type=number] {
  -moz-appearance: textfield;
}

table.lpu-capture-table > tbody > tr.data-row > td.disabled,
table.lpu-capture-table > tbody > tr.data-row > td > input:disabled {
  color: #7e7e7e;
}`, "",{"version":3,"sources":["webpack://./src/style/transformer/SPUCapturing.scss"],"names":[],"mappings":"AAYA;EACI,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,sBAAA;EACA,MAAA;EACA,gBAAA;AAXJ;;AAcA;EACI,8BAAA;AAXJ;;AAcA;EACI,4BAAA;AAXJ;;AAcA;EACI,2BAAA;EACA,yBA3BkB;EA4BlB,6BAAA;EACA,4BAAA;EACA,WAAA;AAXJ;;AAaA;EACI,yBAhCc;EAiCd,6BAAA;EACA,4BAAA;EACA,WAAA;AAVJ;;AAYA;EACI,yBArCiB;EAsCjB,6BAAA;EACA,4BAAA;EACA,WAAA;AATJ;;AAWA;EACI,yBA1CqB;AAkCzB;;AAWA;EACI,6BAAA;EACA,sBAAA;EACA,cAAA;EACA,yBA9Ca;AAsCjB;;AAWA;EACI,mBAAA;AARJ;;AAWA;EACI,2BAAA;AARJ;;AAWA;EACI,8BAAA;AARJ;;AAWA;EACI,4BAAA;EACA,WAAA;AARJ;;AAWA;EACI,yBAzEkB;AAiEtB;;AAWA;EACI,8BAAA;AARJ;;AAWA;EACI,yBArFa;AA6EjB;;AAWA;EACI,4BAAA;EACA,WAAA;AARJ;;AAWA;EACI,yBAzFc;AAiFlB;;AAWA;EACI,yBAjGS;AAyFb;;AAUA;EACI,yBA/FiB;EAgGjB,4BAAA;EACA,WAAA;AAPJ;;AAUA;EACI,yBArGiB;AA8FrB;;AAUA;EACI,yBA7GY;AAsGhB;;AAUA;EACI,4BAAA;EACA,cAAA;AAPJ;;AAUA;EACI,yBAjHqB;AA0GzB;;AAUA;EACI,yBAzHgB;AAkHpB;;AAUA;EACI,yBAvHa;AAgHjB;;AAUA;EACI,yBA5Ha;AAqHjB;;AAUA;EACI,gBAAA;EACA,0BAAA;EACA,sBAAA;EACA,cAAA;EAEA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,iBAAA;EAEA,uBAAA;AATJ;;AAWA;EACI,aAAA;EACA,wBAAA;EACA,mBAAA;AARJ;;AAWA;;EAEE,wBAAA;EACA,SAAA;AARF;;AAWA,YAAA;AACA;EACE,0BAAA;AARF;;AAWA;;EAEI,cAAA;AARJ","sourcesContent":["$COLOR_WAYPOINT: get('colors.table.capturing.spu.waypoint');\n$COLOR_POLE: get('colors.table.capturing.spu.pole');\n$COLOR_ACCOUNT: get('colors.table.capturing.spu.account');\n$COLOR_TOTAL_USAGE: get('colors.table.capturing.spu.totalUsage');\n$COLOR_WAYPOINT_EVEN: get('colors.table.capturing.spu.waypointEven');\n$COLOR_POLE_EVEN: get('colors.table.capturing.spu.poleEven');\n$COLOR_ACCOUNT_EVEN: get('colors.table.capturing.spu.accountEven');\n$COLOR_TOTAL_USAGE_EVEN: get('colors.table.capturing.spu.totalUsageEven');\n$COLOR_OLD_RATE: get('colors.table.capturing.spu.oldRate');\n$COLOR_NEW_RATE: get('colors.table.capturing.spu.newRate');\n$COLOR_EVEN_ROW: get('colors.table.capturing.spu.evenRow');\n\ntable.spu-capture-table > thead > tr.header-row > th {\n    font: bold 15px/15px 'Roboto';\n    letter-spacing: 0.3px;\n    color: #424242;\n    background-color: #FFF;\n    top: 0;\n    position: sticky;\n}\n\ntable.spu-capture-table > thead > tr.header-row > th:nth-child(n + 5) {\n    border-left: 1px #A0A0A0 solid;\n}\n\ntable.spu-capture-table > thead > tr.header-row > th:last-child {\n    border-top-right-radius: 4px;\n}\n\ntable.spu-capture-table > thead > tr.header-row > th.waypoint {\n    border-top-left-radius: 4px;\n    background-color: $COLOR_WAYPOINT_EVEN;\n    border-bottom: 1px #FFF solid;\n    border-right: 1px #FFF solid;\n    color: #FFF;\n}\ntable.spu-capture-table > thead > tr.header-row > th.pole {\n    background-color: $COLOR_POLE_EVEN;\n    border-bottom: 1px #FFF solid;\n    border-right: 1px #FFF solid;\n    color: #FFF;\n}\ntable.spu-capture-table > thead > tr.header-row > th.account {\n    background-color: $COLOR_ACCOUNT_EVEN;\n    border-bottom: 1px #FFF solid;\n    border-right: 1px #FFF solid;\n    color: #FFF;\n}\ntable.spu-capture-table > thead > tr.header-row > th.total-usage {\n    background-color: $COLOR_TOTAL_USAGE_EVEN;\n}\n\ntable.spu-capture-table > tbody > tr.data-row:nth-child(even) {\n    font: bold 11px/15px 'Roboto';\n    letter-spacing: 0.22px;\n    color: #424242;\n    background-color: $COLOR_EVEN_ROW;\n}\n\ntable.spu-capture-table > tbody > tr.data-row > td {\n    border-bottom: none;\n}\n\ntable.spu-capture-table > tbody > tr.data-row > td:nth-child(n + 2) {\n    font: bold 12px/15px Roboto;\n}\n\ntable.spu-capture-table > tbody > tr.data-row > td:nth-child(n + 5) {\n    border-left: 1px #A0A0A0 solid;\n}\n\ntable.spu-capture-table > tbody > tr.data-row > td.waypoint {\n    border-right: 1px #FFF solid;\n    color: #FFF;\n}\n\ntable.spu-capture-table > tbody > tr.data-row:nth-child(even) > td.waypoint {\n    background-color: $COLOR_WAYPOINT_EVEN;\n}\n\ntable.spu-capture-table > tbody > tr.data-row:nth-last-child(1) > td.waypoint {\n    border-bottom-left-radius: 4px;\n}\n\ntable.spu-capture-table > tbody > tr.data-row:nth-child(odd) > td.waypoint {\n    background-color: $COLOR_WAYPOINT;\n}\n\ntable.spu-capture-table > tbody > tr.data-row > td.pole {\n    border-right: 1px #FFF solid;\n    color: #FFF;\n}\n\ntable.spu-capture-table > tbody > tr.data-row:nth-child(even) > td.pole {\n    background-color: $COLOR_POLE_EVEN;\n}\n\ntable.spu-capture-table > tbody > tr.data-row:nth-child(odd) > td.pole {\n    background-color: $COLOR_POLE;\n}\ntable.spu-capture-table > tbody > tr.data-row > td.account {\n    background-color: $COLOR_ACCOUNT_EVEN;\n    border-right: 1px #FFF solid;\n    color: #FFF;\n}\n\ntable.spu-capture-table > tbody > tr.data-row:nth-child(even) > td.account {\n    background-color: $COLOR_ACCOUNT_EVEN;\n}\n\ntable.spu-capture-table > tbody > tr.data-row:nth-child(odd) > td.account {\n    background-color: $COLOR_ACCOUNT;\n}\n\ntable.spu-capture-table > tbody > tr.data-row > td.total-usage {\n    border-right: 1px #FFF solid;\n    color: #424242;\n}\n\ntable.spu-capture-table > tbody > tr.data-row:nth-child(even) > td.total-usage {\n    background-color: $COLOR_TOTAL_USAGE_EVEN;\n}\n\ntable.spu-capture-table > tbody > tr.data-row:nth-child(odd) > td.total-usage {\n    background-color: $COLOR_TOTAL_USAGE;\n}\n\ntable.spu-capture-table > tbody > tr.data-row.multi:nth-child(even) {\n    background-color: $COLOR_NEW_RATE;\n}\n\ntable.spu-capture-table > tbody > tr.data-row.multi:nth-child(odd) {\n    background-color: $COLOR_OLD_RATE;\n}\n\ntable.spu-capture-table > tbody > tr.data-row input {\n    text-align: left;\n    font: 700 12px/15px Roboto;\n    letter-spacing: 0.26px;\n    color: #424242;\n\n    border: none;\n    background-color: transparent;\n    padding: 0px;\n    margin-left: 10px;\n\n    cursor: text !important;\n}\ntable.spu-capture-table > tbody > tr.data-row input:focus {\n    outline: none;    \n    border-bottom: 1px solid;\n    margin-bottom: -1px;\n}\n\ntable.spu-capture-table > tbody > tr.data-row input::-webkit-outer-spin-button,\ntable.spu-capture-table > tbody > tr.data-row input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ntable.spu-capture-table > tbody > tr.data-row input[type=number] {\n  -moz-appearance: textfield;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row > td.disabled,\ntable.lpu-capture-table > tbody > tr.data-row > td > input:disabled {\n    color: #7e7e7e;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
